module.exports = __webpack_public_path__ + "static/media/guide6.76522026.png";